import { render } from "./MovinGuy.vue?vue&type=template&id=12a6e1bb"
import script from "./MovinGuy.vue?vue&type=script&lang=js"
export * from "./MovinGuy.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__